import React from 'react';
import I18n from 'i18n-js';
import { tv } from 'tailwind-variants';
import useFlags from '@/hooks/useFlags';
import DottedLine from '@/components/shared/NewLessonOverview/Header/DottedLine';
import StandardsPillGroup from '@/components/shared/StandardsPills/StandardsPillGroup';
import useLessonOverviewContext from '@/components/shared/NewLessonOverview/useLessonOverviewContext';
import Text from '@/components/ui/Text';
import cn from '@/utils/cn';

const headerRowStyles = tv({
  base: 'tw-flex tw-items-center tw-justify-between tw-mb-4',
  variants: {
    reflow: {
      false: 'tw-mx-8',
      true: 'tw-mx-0',
    },
  },
});

const dottedLineStyles = tv({
  base: '',
  variants: {
    reflow: {
      false: 'tw-mx-8',
      true: 'tw-mx-0',
    },
  },
});

const headerStyles = tv({
  base: '',
  variants: {
    reflow: {
      true: 'tw-text-xl reflow-narrow:tw-text-2xl tw-text-ellipsis tw-overflow-hidden',
    },
  },
});

const Header = () => {
  const { accessibilityReflow } = useFlags();
  const lesson = useLessonOverviewContext(state => state.lesson);
  const locale = useLessonOverviewContext(state => state.locale);
  const programColor = useLessonOverviewContext(state => state.programColor);
  const isStaffer = useLessonOverviewContext(state => state.isStaffer);

  return (
    <div className="tw-py-4">
      <div className={headerRowStyles({ reflow: accessibilityReflow })}>
        <div className="tw-flex tw-items-center tw-min-w-0 tw-flex-1">
          <div
            className={cn('tw-w-40 tw-relative tw--left-10 tw-h-12 tw-flex tw-items-center tw-justify-center',
              'tw-pl-2 tw-flex-shrink-0 tw-rounded-r-full')}
            style={{ backgroundColor: `#${programColor}0d` }}
          >
            <p
              className="tw-p-0 tw-m-0 tw-leading-7 tw-flex tw-items-center"
              style={{ color: `#${programColor}` }}
            >
              <Text size="xl" tag="span" variant="label">{I18n.t('lesson')}</Text>
              <Text className="tw-ml-4" tag="span" variant="heading1">{lesson.titleNumber}</Text>
            </p>
          </div>
          <Text
            className={cn(
              'tw-relative tw--left-6 tw-bg-white tw-min-w-0',
              headerStyles({ reflow: accessibilityReflow }),
            )}
            tag="p"
            variant="heading2"
          >
            {lesson.title}
          </Text>
        </div>
        {isStaffer && (
          <StandardsPillGroup
            heading={I18n.t('standards_correlation_for_this_lesson')}
            label={I18n.t('lesson_standards')}
            locale={locale}
            standards={lesson.tags}
          />
        )}
      </div>
      <DottedLine className={dottedLineStyles({ reflow: accessibilityReflow })} color={programColor} />
    </div>
  );
};

export default Header;
